<div class="content-page col-12" style="max-width: 100vw; min-width: 65vw;">
    <header class="col-12 header-page">
        <div class="logo-container">
            <img src="assets/img/png/logo-atualizada.PNG" alt="Logo" class="logo">
        </div>
        <div class="header-content">
            <h1 class="titulo-pe">
                Construa o Seu Futuro Financeiro
            </h1>
            <p class="subtitulo">Simule o valor do seu “Pé de Meia” com facilidade e precisão</p>
        </div>
    </header>

    <body>
        <form [formGroup]="formData" (ngSubmit)="simular()">
            <section class="form-container">
                <div class="input-group">
                    <div class="input-field">
                        <label class="form-label">Data de Nascimento <span class="required">*</span></label>
                        <input (keyup)="simular()" type="date" class="form-input" formControlName="dataNascimento" />
                        <small class="form-error"
                            *ngIf="formData.get('dataNascimento')?.touched && formData.get('dataNascimento')?.invalid">
                            Por favor, informe a Data de Nascimento!
                        </small>
                    </div>
                    <div class="input-field">
                        <label class="form-label">Idade Aposentadoria <span class="required">*</span></label>
                        <input (keyup)="simular()" class="form-input" mask="000" maxlength="3"
                            formControlName="idadeAposentadoria" placeholder="Informe a Idade de Aposentadoria" />
                        <small class="form-error"
                            *ngIf="formData.get('idadeAposentadoria')?.touched && formData.get('idadeAposentadoria')?.invalid">
                            Por favor, informe a Idade de Aposentadoria!
                        </small>
                    </div>
                    <div class="input-field">
                        <label class="form-label">Quero investir mensalmente <span class="required">*</span></label>
                        <input class="form-input" placeholder="R$ 0,00" maxlength="14"
                            [options]="{ prefix: 'R$ ', thousands: '.', decimal: ',' }"
                            formControlName="contribuicaoMensal" currencyMask (keyup)="simular()" />
                        <small class="form-text">Valor sugerido R$100,00</small>
                    </div>
                </div>
                <!-- Aporte Inicial e Valor da Portabilidade -->
                <div class="input-group capital-group"
                    *ngIf="formData.get('dataNascimento')?.value != null && formData.get('idadeAposentadoria')?.value != null">
                    <div class="input-field">
                        <label class="form-label">Aporte Inicial</label>
                        <input class="form-input" placeholder="R$ 0,00" maxlength="14" formControlName="aporteInicial"
                            [options]="{ prefix: 'R$ ', thousands: '.', decimal: ',' }" currencyMask
                            (keyup)="simular()" />
                        <small class="form-error"
                            *ngIf="formData.get('aporteInicial')?.touched && formData.get('aporteInicial')?.invalid">
                            Por favor, selecione o valor para o Aporte Inicial
                        </small>
                    </div>
                    <div class="input-field">
                        <label class="form-label">Valor da Portabilidade</label>
                        <input class="form-input" placeholder="R$ 0,00" maxlength="14" formControlName="portabilidade"
                            [options]="{ prefix: 'R$ ', thousands: '.', decimal: ',' }" currencyMask
                            (keyup)="simular()" />
                        <small class="form-error"
                            *ngIf="formData.get('portabilidade')?.touched && formData.get('portabilidade')?.invalid">
                            Por favor, selecione o valor para a Portabilidade
                        </small>
                    </div>
                </div>
                <div class="capital-info" *ngIf="formData.get('portabilidade')?.value >= 65000">
                    <p>Perfeito!! Com esse valor você já pode solicitar sua renda mensal no valor de <b>{{
                            formData.get('portabilidade')?.value / ((numeroAnos * 12) + numeroAnos) |
                            currency:'BRL':'symbol':'1.2-2':'pt' }}</b> por {{ numeroAnos }} anos!</p>
                </div>
                <button class="form-submit" [disabled]="formData.invalid">
                    Simular
                </button>
            </section>
        </form>
        <section>
            <section class="content-planoCompleto col-xl-5" style="margin-top: 4rem; margin-bottom: 3rem;">
                <h2 style="color: white;">Plano Completo</h2>
                <section class="content-descricao-planoCompleto pt-1">
                    <div>
                        <b class="descricao-planoCompleto-titulo-previdencia">PREVIDÊNCIA</b>
                        <br>
                        <p class="descricao-planoCompleto-descricao-previdencia mt-1">
                            (Renda Futura)
                        </p>
                    </div>
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                        class="bi bi-plus" viewBox="0 0 16 16">
                        <path
                            d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4" />
                    </svg>
                    <div>
                        <b class="descricao-planoCompleto-titulo-risco">COBERTURA DE RISCO</b>
                        <br>
                        <p class="descricao-planoCompleto-descricao-risco mt-1">
                            (Renda Invalidez e/ou Morte)
                        </p>
                    </div>
                </section>
            </section>
            <section *ngIf="valorTotal > 0">
                <div class="d-flex" style="align-items: baseline; gap: 0.5rem; padding-bottom: 0.75rem;">
                    <label class="switch mt-2">
                        <input id="simulacaoAvancada" type="checkbox" (click)="simulacaoAvancada($event)">
                        <span class="slider round"></span>
                    </label>
                    <p style="font-size: 0.875rem; color: black;">
                        Simulação avançada
                    </p>
                </div>
                <section *ngIf="simulacao" class="avancada-simulacao">
                    <section class="p-1 content-prazos">
                        <div class="form-check form-check-inline">
                            <input class="form-check-input" type="radio" name="inlineRadioOptions" id="inlineRadio2"
                                value="2" (click)="alterarPercentual('2')" [checked]="formaRecebimento == 2"
                                [(ngModel)]="formaRecebimento">
                            <label class="form-check-label" for="inlineRadio2">Prazo Determinado</label>
                        </div>
                        <div class="form-check form-check-inline">
                            <input class="form-check-input" type="radio" name="inlineRadioOptions" id="inlineRadio1"
                                value="1" (click)="alterarPercentual('1')" [checked]="formaRecebimento == 1"
                                [(ngModel)]="formaRecebimento">
                            <label class="form-check-label" for="inlineRadio1">Percentual Saldo de Conta</label>
                        </div>
                        <div class="form-check form-check-inline">
                            <input class="form-check-input" type="radio" name="inlineRadioOptions" id="inlineRadio3"
                                value="3" [checked]="formaRecebimento == 3" [(ngModel)]="formaRecebimento">
                            <label class="form-check-label" for="inlineRadio3">Prazo Indeterminado</label>
                        </div>
                    </section>
                    <section class="row">
                        <div class="col-xl-3 col-md-6 col-sm-12 pt-0 px-1" *ngIf="formaRecebimento == 1">
                            <label style="color: #000 !important; padding: 0.125rem 0.25rem;">Percentual
                                <span class="label__form__required">*</span></label>
                            <ng-select class="ng-pristine" id="ngSelect" placeholder="Seleciona a Taxa de Juros"
                                bindValue="valor" bindLabel="chave" [items]="listaPercentual" [clearable]="false"
                                [searchable]="false" [(ngModel)]="percentualSaldo" (change)="simular()">
                            </ng-select>
                            <small class="form-text text-muted danger "
                                *ngIf="formData.get('taxaJurosAnual')?.touched && formData.get('taxaJurosAnual')?.invalid">
                                Por favor, seleciona a taxa!
                            </small>
                        </div>
                        <div class="col-xl-3 col-md-6 col-sm-12 pt-0 px-1" *ngIf="formaRecebimento == 2">
                            <label style="color: #000 !important; padding: 0.125rem 0.25rem;">Prazo em Anos
                                <span class="label__form__required">*</span></label>
                            <ng-select class="ng-pristine" id="ngSelect" placeholder="Número de anos" bindValue="valor"
                                bindLabel="chave" [clearable]="false" [items]="listaAnos" [searchable]="false"
                                [(ngModel)]="numeroAnos" (change)="simular()">
                            </ng-select>
                        </div>
                        <div class="col-xl-3 col-md-6 col-sm-12 pt-0 px-1" *ngIf="formaRecebimento == 3">
                            <label style="color: #000 !important; padding: 0.125rem 0.25rem;">Sexo
                                <span class="label__form__required">*</span></label>
                            <ng-select class="ng-pristine" id="ngSelect" placeholder="Seleciona o sexo"
                                bindValue="valor" bindLabel="chave" [items]="sexos" [searchable]="false"
                                [(ngModel)]="sexo" (change)="alterarPercentual('3')">
                            </ng-select>
                            <small class="form-text text-muted danger "
                                *ngIf="formData.get('sexo')?.touched && formData.get('sexo')?.invalid">
                                Por favor, informe seu sexo!
                            </small>
                        </div>
                        <div class="col-xl-3 col-md-6 col-sm-12 pt-0 px-1">
                            <label style="color: #000 !important; padding: 0.125rem 0.25rem;">
                                Taxa de Juros Anual<span class="label__form__required">*</span></label>
                            <ng-select class="ng-pristine" id="ngSelect" placeholder="Seleciona a Taxa de Juros"
                                bindValue="valor" bindLabel="chave" [items]="listaTaxa" [searchable]="false"
                                [(ngModel)]="taxaJurosAnual" (change)="simular()">
                            </ng-select>
                            <small class="form-text text-muted danger "
                                *ngIf="formData.get('taxaJurosAnual')?.touched && formData.get('taxaJurosAnual')?.invalid">
                                Por favor, seleciona a taxa!
                            </small>
                        </div>
                    </section>
                    <div class="form-check ml-2 mt-1">
                        <input class="form-check-input" type="checkbox" value="" id="calculoAutomatico"
                            (change)="riscoMinimo()">
                        <label class="form-check-label label-calculo-automatico" for="calculoAutomatico">
                            Cálculo automático mínimo para a Cobertura de Invalidez e Morte.
                        </label>
                    </div>
                </section>
                <section class="col-12 px-0 d-flex" *ngIf="loading">
                    <spinner [show]="loading"></spinner>
                </section>
                <section class="col-12 px-0 d-flex" *ngIf="!loading">
                    <section class="content-cards-simulador" style="margin-top: 1rem;"
                        *ngIf="(formaRecebimento == 3 && sexo != null) || formaRecebimento == 1 || formaRecebimento == 2">
                        <div class="card">
                            <section>
                                <div class="card-header">
                                    <h4>PREVIDÊNCIA - RENDA FUTURA</h4>
                                </div>
                                <div class="card-body">
                                    <p class="valor-simulacao">
                                        {{ valorTotal | currency:'BRL':'symbol':'1.2-2':'pt' }}
                                    </p>
                                    <p class="descricao-subtitulo">
                                        Renda aos <b>{{ formData.get('idadeAposentadoria')?.value }} anos</b> é de
                                        <b>{{ rendaRiscoPrevidencia | currency:'BRL':'symbol':'1.2-2':'pt' }}</b>,
                                        com investimento mensal de <b>{{ investimentoMensalPrevidencia |
                                            currency:'BRL':'symbol':'1.2-2':'pt' }}</b>.
                                    </p>
                                </div>
                                <div class="card-rodape">
                                    <h1>.</h1>
                                </div>
                            </section>
                        </div>
                        <div class="bloco-card">
                            <div class="form-check">
                                <input class="form-check-input" type="checkbox" value="" id="flexCheckDefault"
                                    [(ngModel)]="checkboxRiscoInvalidez" (change)="alterarRiscoInvalidez('Invalidez')">
                                <label class="form-check-label" for="flexCheckDefault">
                                    Adicionar Cobertura
                                </label>
                            </div>
                            <div [ngClass]="{'incluir-cobertura': !checkboxRiscoInvalidez}"
                                *ngIf="tempo >= 156 || tempo <= 851" class="card">
                                <section class="card-bloco">
                                    <div class="card-header" [ngClass]="{'centralizado': !checkboxRiscoInvalidez}">
                                        <h4>COBERTURA RISCO INVALIDEZ</h4>
                                    </div>
                                    <div class="card-body">
                                        <p *ngIf="checkboxRiscoInvalidez" class="valor-simulacao">
                                            {{ simulacaoCoberturaInvalidez | currency:'BRL':'symbol':'1.2-2':'pt' }}
                                        </p>
                                        <div *ngIf="checkboxRiscoInvalidez" class="descricao-subtitulo">
                                            <span>Renda para beneficiário em caso de invalidez
                                                <b>{{ rendaRiscoMorte | currency:'BRL':'symbol':'1.2-2':'pt' }}</b>
                                                mensal e investimento mensal de:
                                            </span>
                                        </div>
                                    </div>
                                    <div class="rodape-card" *ngIf="checkboxRiscoInvalidez">
                                        <input [disabled]="!checkboxRiscoInvalidez || !simulacao" [attr.max]="25"
                                            [(ngModel)]="investimentoMensalInvalidez" class="input-simulacao"
                                            placeholder="R$ 0,00" (ngModelChange)="valorMaximo('invalidez')"
                                            [options]="{ prefix: 'R$ ', thousands: '.', decimal: ',' }" currencyMask />
                                        <small
                                            *ngIf="rendaRiscoInvalidez != 0 && 
                                            (simulacaoCoberturaInvalidez < 20000 || simulacaoCoberturaInvalidez > 3000000)">
                                            <p class="valor-incorreto">Informe um valor entre {{ limiteInvalidez.minima
                                                | currency:'BRL':'symbol':'1.2-2':'pt' }} até
                                                {{ limiteInvalidez.maxima | currency:'BRL':'symbol':'1.2-2':'pt' }}
                                            </p>
                                        </small>
                                    </div>
                                </section>
                            </div>
                        </div>
                        <div class="bloco-card">
                            <div class="form-check">
                                <input class="form-check-input" type="checkbox" value="" id="flexCheckDefault2"
                                    [(ngModel)]="checkboxRiscoMorte" (change)="alterarRiscoMorte('Morte')">
                                <label class="form-check-label" for="flexCheckDefault2">
                                    Adicionar Cobertura
                                </label>
                            </div>
                            <div [ngClass]="{'incluir-cobertura': !checkboxRiscoMorte}"
                                *ngIf="tempo >= 156 || tempo <= 851" class="card">
                                <section class="card-bloco">
                                    <div class="card-header" [ngClass]="{'centralizado': !checkboxRiscoMorte}">
                                        <h4>COBERTURA RISCO MORTE</h4>
                                    </div>
                                    <div class="card-body">
                                        <p *ngIf="checkboxRiscoMorte" class="valor-simulacao">
                                            {{ simulacaoCoberturaMorte | currency:'BRL':'symbol':'1.2-2':'pt' }}
                                        </p>
                                        <div *ngIf="checkboxRiscoMorte" class="descricao-subtitulo">
                                            <span>Renda para beneficiário em caso de morte
                                                <b>{{ rendaRiscoMorte | currency:'BRL':'symbol':'1.2-2':'pt' }}</b>
                                                mensal e investimento mensal de:
                                            </span>
                                        </div>
                                    </div>
                                    <div class="rodape-card" *ngIf="checkboxRiscoMorte">
                                        <input [disabled]="!checkboxRiscoMorte || !simulacao" [attr.max]="25"
                                            [(ngModel)]="investimentoMensalMorte" class="input-simulacao"
                                            placeholder="R$ 0,00" (ngModelChange)="valorMaximo('morte')"
                                            [options]="{ prefix: 'R$ ', thousands: '.', decimal: ',' }" currencyMask />
                                        <small *ngIf="rendaRiscoMorte != 0 && 
                                        (simulacaoCoberturaMorte < 20000 || simulacaoCoberturaMorte > 3000000)">
                                            <p class="valor-incorreto">Informe um valor entre {{ limiteMorte.minima |
                                                currency:'BRL':'symbol':'1.2-2':'pt' }} até
                                                {{ limiteMorte.maxima | currency:'BRL':'symbol':'1.2-2':'pt' }}
                                            </p>
                                        </small>
                                    </div>
                                </section>
                            </div>
                        </div>
                        <div>
                            <section>
                                <div class="card total">
                                    <div>
                                        <h4>TOTAL</h4>
                                    </div>
                                    <div>
                                        <p>{{ (this.investimentoMensalMorte +
                                            this.investimentoMensalInvalidez + this.investimentoMensalPrevidencia) |
                                            currency:'BRL':'symbol':'1.2-2':'pt'}}</p>
                                    </div>
                                </div>
                            </section>
                        </div>
                    </section>
                    <section>
                    </section>
                </section>
                <p style="font-size: 0.775rem; padding-top: 2rem; padding-bottom: 2rem;color: #999494;"
                    *ngIf="!loading">
                    Os valores apresentados são apenas projeções, calculadas com uma taxa de juros de
                    <b>{{taxaJurosAnual + '%'}}</b> ao ano.
                    <span [ngSwitch]="formaRecebimento">
                        <span *ngSwitchCase="'1'"></span>
                        <span *ngSwitchCase="'2'" style="font-size: 0.775rem !important;">Prazo em anos de
                            <b>{{numeroAnos}} anos!</b></span>
                        <span *ngSwitchCase="'3'"></span>
                    </span>
                </p>
                <div class="graficos">
                    <div class="grafico-subida">
                        <section class="pie-chart">
                            <section class="content-chart-pie row">
                                <canvas id="linechart"></canvas>
                                <section class="content-chart-legendas col-12">
                                    <div class="legenda">
                                        <span class="legenda-chart legenda-participante"></span>
                                        <span>Valor Contribuído: {{valorBruto | currency:'BRL'}}</span>
                                    </div>
                                    <div class="legenda">
                                        <span class="legenda-chart legenda-rentabilidade"></span>
                                        <span>Rentabilidade: {{valorRendimentos | currency:'BRL'}}</span>
                                    </div>
                                    <div class="legenda">
                                        <span class="legenda-chart legenda-total"></span>
                                        <span>Valor Total: {{valorTotal | currency:'BRL'}}</span>
                                    </div>
                                </section>
                            </section>
                        </section>
                    </div>
                    <div class="div-grafico-chart">
                        <section class="pie-chart">
                            <section class="content-chart-pie row">
                                <canvas id="piechart" class="col-12"></canvas>
                                <section class="content-chart-legendas col-12">
                                    <div class="legenda">
                                        <span class="legenda-chart legenda-participante"></span>
                                        <span>Valor Contribuído: {{valorBruto | currency:'BRL'}}</span>
                                    </div>
                                    <div class="legenda">
                                        <span class="legenda-chart legenda-rentabilidade"></span>
                                        <span>Rentabilidade: {{valorRendimentos | currency:'BRL'}}</span>
                                    </div>
                                    <div class="legenda">
                                        <span class="legenda-chart legenda-total"></span>
                                        <span>Valor Total: {{valorTotal | currency:'BRL'}}</span>
                                    </div>
                                </section>
                            </section>
                        </section>
                    </div>
                </div>
                <footer style="display: flex; justify-content: end; margin-bottom: 0.5rem;" *ngIf="!loading">
                    <a type="button" [routerLink]="['/adesao-plano-familia']" (click)="redirecionaAdesao()"
                        class="btn btn-primary btn-redirecionamento float-right">
                        <span>Quero fazer agora</span>
                    </a>
                </footer>
            </section>
        </section>
    </body>
</div>